import ModalEquiposAdicionalesVenta from "@/erp/inventario/ingreso-producto/shared/componente/ModalEquiposAdicionalesVenta";
import ModalCuotas from "@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas";
import { CANTIDAD_CHOICE, CUOTAS_CHOICE, gridSizeConst1, gridSizeConst2, gridSizeConst6, gridSizeMdLg12 } from "@/shared";
import { CustomAutocompleteArrStringNoForm } from "@/shared/components/ui";
import { IEquipoServicioAdicionales, OrdenTrabajo, TipoVentaEnum } from "@/shared/interfaces";
import { useEquiposAdicionales } from "@/store/erp";
import { Delete, Visibility } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<Partial<OrdenTrabajo>>
    onlyShow?:boolean;
}

export const EquiposAdicionalesParaVenta = ({form, onlyShow=false}: Props) => {

    const productos = useEquiposAdicionales(s => s.productos)
    const setMaterialesEquiposAdicionales = useEquiposAdicionales(s => s.setProductos)
    const handleAgregarProducto = useEquiposAdicionales(s => s.handleAgregarProducto)
    const handleActualizarProducto = useEquiposAdicionales(s => s.handleActualizarProducto)
    const getDataProducto = useEquiposAdicionales(s => s.getDataProducto)
    const handleEliminarProducto = useEquiposAdicionales(s => s.handleEliminarProducto)
    // const handleSetAllProductos = useEquiposAdicionales(s => s.handleSetAllProductos)

    useEffect(() => {
        if(form.getValues().materiales_equipos_adicionales 
        && (form.getValues()?.materiales_equipos_adicionales?.length||0)>0){
          setMaterialesEquiposAdicionales(form.getValues()?.materiales_equipos_adicionales)
            // handleSetAllProductos(form.getValues()?.materiales_equipos_adicionales)
        }else{
          setMaterialesEquiposAdicionales([])
        }
    }, []);
    useEffect(() => {
        form.reset({
            ...form.getValues(),
            materiales_equipos_adicionales: productos,
        })
    }, [productos]);


    return (
    <>

    <Grid {...gridSizeMdLg12} container justifyContent={"end"}>
        <ModalEquiposAdicionalesVenta
          textButton="Agregar"
          onlyShow={onlyShow}
          onChange={(e) => {

            const nuevoProducto: IEquipoServicioAdicionales = {
              id: e.id_producto,
              codigo: e.codigo,
              cantidad: "1",
              cuotas: "1",
              tipoVenta: TipoVentaEnum.EQUIPO,
              precios: e.precios,
              descripcion: e.descripcion
            };

            handleAgregarProducto(nuevoProducto)

          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid
          item
          container
          spacing={3}
          // justifyContent={"space-between"}
          {...gridSizeMdLg12}

        >
          {
            productos.filter(e => e.tipoVenta == TipoVentaEnum.EQUIPO).map((element) => {
              return <Grid
                item
                container
                spacing={1}
                {...gridSizeMdLg12}
                key={element.codigo}
              >

                <Grid item {...gridSizeConst6}>
                  <Typography variant="subtitle2">
                    {element.descripcion}
                  </Typography>
                </Grid>

                <CustomAutocompleteArrStringNoForm
                  label="Cantidad"
                  options={CANTIDAD_CHOICE}
                  size={gridSizeConst2}
                  defaultValue={element.cantidad ?? '1'}
                  onChangeValue={(value) => {
                    handleActualizarProducto(element.id!, { cantidad: value })
                  }}
                  disabled={onlyShow}
                />

                <CustomAutocompleteArrStringNoForm
                  label="Cuotas"
                  options={CUOTAS_CHOICE}
                  size={gridSizeConst2}
                  defaultValue={element.cuotas ?? '1'}
                  onChangeValue={(value) => {
                    handleActualizarProducto(element.id!, { cuotas: value })
                  }}
                  disabled={onlyShow}
                />

                {
                  !onlyShow &&
                  <Grid item {...gridSizeConst1}>
                  <IconButton
                    onClick={() => {
                      const findProducto = productos.find(e => e.id == element.id!);
                      getDataProducto(findProducto);
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </Grid>}
                {
                  !onlyShow &&
                  <Grid item {...gridSizeConst1}>
                    <IconButton
                      onClick={() => {
                        handleEliminarProducto(element.id!);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Grid>
                }

              </Grid>
            })
          }
          {
            productos && productos?.length==0 &&
            <Grid item container>
              <Typography variant="body1" color={"gray"}>
                Aún no se han añadido equipos adicionales
              </Typography>
            </Grid>
          }

        </Grid>
        <ModalCuotas />
      </Grid>



    </>
  )
}

